import styled from 'styled-components';

const StyledIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size || 24}px;
  height: ${props => props.size || 24}px;
  transform: rotate(${props => props.rotate || 0}deg);

  svg {
    width: ${props => props.size || 24}px;
    height: ${props => props.size || 24}px;

    /* Apply color either as fill (default) or as stroke based on colorMode prop */
    ${props => (props.colorMode === 'stroke') ? `
      path, circle, rect, polygon, line, polyline {
        stroke: ${props.color || props.theme.colors.neutral_6};
      }
    ` : `
      path, circle, rect, polygon, line, polyline {
        fill: ${props.color || props.theme.colors.neutral_6};
      }
    `}
  }
`;


export {
  StyledIconWrapper,
}
